import { Component, OnInit } from '@angular/core';
import { Categoria, CategoriaOrigem } from "../../models/categoria";
import { ActivatedRoute, Router } from '@angular/router';
import { NotificacaoService } from '../../services/notificacao.service';
import { CarregandoService } from '../../services/carregando.service';
import { CategoriaService } from '../../services/categoria.service';
import { IconesModalComponent } from "../../modals/icones-modal/icones-modal.component";
import { MatDialog } from "@angular/material";
import swal from "sweetalert2";

@Component({
  selector: 'app-cadastrar-categoria',
  templateUrl: './cadastrar-categoria.component.html',
  styleUrls: ['./cadastrar-categoria.component.scss']
})
export class CadastrarCategoriaComponent implements OnInit {

  idCategoria = "0";
  categoria = new Categoria();
  status = [
    { id: 1, descricao: "Ativo" },
    { id: 0, descricao: "Bloqueado" },
  ];
  origens = [
    { id: 0, descricao: "Kit Customizado" },
    { id: 1, descricao: "Kit Fechado" },
    { id: 2, descricao: "Avulso" }
  ];
  origensSelecionadas = [];
  editando = false;
  carregando = true;
  travaOrigemKit = false;

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private categoriaService: CategoriaService,
    private router: Router,
    private carregandoService: CarregandoService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    if (this.route.snapshot.paramMap.get('id')) {
      this.idCategoria = this.route.snapshot.paramMap.get('id');
      this.editando = true;

      if (this.idCategoria === "7") {
        this.travaOrigemKit = true;
      }

      this.buscarCategoria();
    } else {
      this.categoria = new Categoria();
      this.categoria.ativo = 1;
    }
  }

  buscarCategoria(){
    this.carregandoService.mostra('buscaCategoria');
    this.categoriaService.buscar(this.idCategoria).subscribe(data => {
      this.categoria = data;

      if (this.categoria.origens.length > 0) {
        this.origensSelecionadas = this.categoria.origens.map(o => o.idOrigem);
      }

      this.carregando = false;
      this.carregandoService.esconde('buscaCategoria');
    }, erro => {
      this.notificacaoService.erro(erro);
      this.carregando = false;
      this.carregandoService.esconde('buscaCategoria');
    });
  }

  selecionarIcone(icone: string | undefined) {
    this.categoria.icone = icone;
  }

  salvar() {
    let origemCategoria: CategoriaOrigem[] = [];

    if (this.origensSelecionadas.length > 0) {
      this.origensSelecionadas.forEach(o => {
        let origem = new CategoriaOrigem();
        origem.idCategoria = Number(this.idCategoria);
        origem.idOrigem = o;

        origemCategoria.push(origem)
      });

      this.categoria.origens = origemCategoria;
    }

    this.carregandoService.mostra('salvarCategoria');
    this.categoriaService.salvar(this.categoria).subscribe(data => {
      this.notificacaoService.sucesso('Categoria salva com sucesso!');
      this.carregandoService.esconde('salvarCategoria');
      this.router.navigate(['/configuracoes/categoria']);
    }, erro => {
      this.notificacaoService.erro(erro);
      this.carregandoService.esconde('salvarCategoria');
    });
  }

}
